import { Liquid } from 'liquidjs'

const liquidEngine = new Liquid()

export default liquidEngine
